import React, { useEffect, useState } from "react";
import { Card, Form, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { FormHelper } from "utils";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import { InputSidebarContainer } from "components";
import ModalContainer from "components/ModalContainer/ModalContainer";
import Attachments from "components/Attachment/Attachment";
import EditHeader from "components/PantallasEdit/Header/EditHeader";
import SectionRow from "components/PantallasEdit/SectionRow/SectionRow";
import EditContainer from "components/PantallasEdit/EditContainer/EditContainer";
import InputContainer from "components/PantallasEdit/InputContainer/InputContainer";
import useQueryParams from "hooks/useQueryParams";
import { Compania } from "models/Compania";
import { CompaniaManager, TenantManager, SolicitudCompaniaTenantManager as SolicitudManager } from "managers";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import { useTheme, useAuthentication } from "hooks";
import {
  TIPO_SOLICITUD_ACTIVACION,
  ESTATUS_PENDIENTE
}
  from "models/SolicitudesCompaniaTenant"

export default function CompaniaVinculadaEdit({ showLoading, hideLoading }) {
  const [compania, setCompania] = useState({});
  const [tituloHeader, setTituloHeader] = useState("Crear Compañia");
  const [mostrarConfiguracionSistemaExterno, setMostrarConfiguracionSistemaExterno] = useState(false);
  const [showAdjuntarDocumentosModal, setShowAdjuntarDocumentosModal] = useState();
  const [modal, setModal] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [attachmentCount, setAttachmentCount] = useState(0);

  const { usuario, tienePermiso } = useAuthentication();

  const URLParameters = useQueryParams();
  const Id = URLParameters.get("Id");
  const esNuevo = !Id;
  const { Message, cerrarAlertas, Types, Warning } = useMessage();
  const { handleException } = useExceptionHandler();
  const { theme, vendorTheme } = useTheme();
  const history = useHistory();

  useEffect(() => {
    if (!usuario?.Compania?.EsTenant) {
      Warning({
        message: `Usuario no tiene permiso.`
      });
      return;
    }

    if (Id) {
      showLoading();
      cargarCompania(Id);
      setTituloHeader("Editar Solicitud");
    } else {
      setDefaultValues();
      cerrarAlertas();
    }
    hideLoading();
    return () => { };
  }, [Id]);

  const setDefaultValues = () => {
    let color1 = "#F16101";
    let color2 = "#8AA8B0";
    let color3 = "#FFFFFF";

    if (theme.title == "GN ECF") {
      color1 = "#D52B1E";
      color2 = "#1097AF";
      color3 = "#FFFFFF";
    }

    setCompania({
      ...Compania,
      Estatus: Compania.DEFAULT_ESTATUS_VALUE,
      Ambiente: Compania.DEFAULT_AMBIENTE_VALUE,
      Nombre: "",
      RazonSocial: "",
      Codigo: "",
      RNC: "",
      DireccionLinea1: "",
      TelefonoPrincipal: "",
      TelefonoSecundario: "",
      Email: "",
      Color1: color1,
      Color2: color2,
      Color3: color3,
      PaginaWeb: "",
      Extension1: "",
      Extension2: "",
      Fax: "",
      ConfiguracionSistemaExterno: "",
      ClienteId: 0,
      EsPrincipal: false
    });
    setMostrarConfiguracionSistemaExterno(false);
  };

  const setCheckedProp = (e) => {
    const { name, checked } = e.target;
    setCompania({
      ...compania,
      [name]: checked,
    });
  };

  const cargarCompania = (Id) => {
    SolicitudManager
      .buscarSolicitudCompaniaTenantPorId({ IdSec: Id, CompaniaId: usuario.CompaniaId })
      .then((data) => {
        data.compania.Color1 = "#" + data.compania.Color1;
        data.compania.Color2 = "#" + data.compania.Color2;
        data.compania.Color3 = "#" + data.compania.Color3;
        setCompania({ ...data.compania });

        const isReadonly = data.solicitud.Estatus != ESTATUS_PENDIENTE
        setIsReadonly(isReadonly);
      });
  };

  function grabar() {
    showLoading();
    if (esNuevo) {
      const companiaNueva = {
        ...compania,
        CompaniaTenantId: usuario.CompaniaId
      };

      setCompania(companiaNueva);
      const formularioJson = JSON.stringify(companiaNueva);

      const solicitudActivacion = {
        TipoSolicitud: TIPO_SOLICITUD_ACTIVACION,
        FormularioJson: formularioJson
      };

      SolicitudManager
        .crearCompaniaVinculada(solicitudActivacion)
        .then((_res) => {
          Message({ message: `Solicitud creada exitosamente` });
          let urlBase = `/CompaniaVinculadaEdit?Id=${_res.Data.IdSec}`;
          history.push(urlBase);
        })
        .catch((e) => {
          handleException(e)
          return;
        })
        .finally(() => {
          hideLoading();
        });
    } else {
      const formularioJsonEdit = JSON.stringify(compania);

      const solicitudEditRequest = {
        IdSec: Id,
        CompaniaId: usuario.CompaniaId,
        TipoSolicitud: TIPO_SOLICITUD_ACTIVACION,
        FormularioJson: formularioJsonEdit
      };

      SolicitudManager
        .editarSolicitudCompaniaTenant(solicitudEditRequest)
        .then(() => {
          Message({ message: `Actualizado Exitosamente` });
          cargarCompania(Id);
        })
        .catch((e) => handleException(e))
        .finally(() => {
          hideLoading();
        });
    }
  }

  const handleVolverClick = () => {
    let urlBase = `/SolicitudCompaniaTenantList?t=true`;
    history.push(urlBase);
  }

  const adjuntarDocumentoModal = (
    <ModalContainer
      showModal={showAdjuntarDocumentosModal}
      size="lg"
      title="Adjuntar Documentos"
      btnGrabar={{
        show: false
      }}
      cerrar={() => {
        setShowAdjuntarDocumentosModal(false);
      }}
    >
      <EditSection>
        <Attachments
          readonly={isReadonly}
          showLoading={() => { }}
          hideLoading={() => { }}
          companiaId={usuario.CompaniaId}
          fuente="SolicitudesCompaniaTenant"
          modulo="ECF"
          referencia={Id}
          ocultarHeader={true}
          modal={modal}
          setModal={setModal}
          setAttachmentCount={setAttachmentCount}
        />
      </EditSection>
    </ModalContainer>
  )

  return (
    <>
      {showAdjuntarDocumentosModal && adjuntarDocumentoModal}

      <Form action="" className="form-horizontal" method="">
        <Card>
          <EditHeader
            titulo={`${tituloHeader}`}
            volver={true}
            vovlerFunc={handleVolverClick}
            {...!isReadonly && { grabar: () => grabar() }}
            {...!esNuevo && { adjuntarDocumento: () => setShowAdjuntarDocumentosModal(true) }}
          />
          <EditContainer>
            <EditSection title="Información General">
              <SectionRow>
                <InputContainer label="Id">
                  <Form.Control
                    type="number"
                    name="Id"
                    value={compania.Id}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    disabled={true}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Nombre">
                  <Form.Control
                    type="text"
                    name="Nombre"
                    value={compania.Nombre}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Razón Social">
                  <Form.Control
                    type="text"
                    name="RazonSocial"
                    value={compania.RazonSocial}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Código">
                  <Form.Control
                    type="text"
                    name="Codigo"
                    value={compania.Codigo}
                    onChange={(e) =>
                      FormHelper.handleChangeNoEspace(e, setCompania)
                    }
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="RNC">
                  <Form.Control
                    type="text"
                    name="RNC"
                    value={compania.RNC}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Dirección">
                  <Form.Control
                    type="text"
                    name="DireccionLinea1"
                    value={compania.DireccionLinea1}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Teléfono Principal">
                  <Form.Control
                    type="text"
                    name="TelefonoPrincipal"
                    value={compania.TelefonoPrincipal}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                    disabled={isReadonly}
                  />
                </InputContainer>
                <InputContainer label="Extensión 1">
                  <Form.Control
                    type="text"
                    name="Extension1"
                    value={compania.Extension1}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Teléfono Secundario">
                  <Form.Control
                    type="text"
                    name="TelefonoSecundario"
                    value={compania.TelefonoSecundario}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                    disabled={isReadonly}
                  />
                </InputContainer>

                <InputContainer label="Extensión 2">
                  <Form.Control
                    type="text"
                    name="Extension2"
                    value={compania.Extension2}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Correo">
                  <Form.Control
                    type="text"
                    name="Email"
                    value={compania.Email}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    disabled={isReadonly}
                  />
                </InputContainer>
                <InputContainer label="Fax">
                  <Form.Control
                    type="text"
                    name="Fax"
                    value={compania.Fax}
                    onChange={(e) =>
                      FormHelper.handleChangeSoloNumero(e, setCompania)
                    }
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>

              <SectionRow>
                <InputContainer label="Página Web">
                  <Form.Control
                    type="text"
                    name="PaginaWeb"
                    value={compania.PaginaWeb}
                    onChange={(e) => FormHelper.handleChange(e, setCompania)}
                    disabled={isReadonly}
                  />
                </InputContainer>
              </SectionRow>
            </EditSection>
            <EditSection title="Apariencia">
              <EditSection title="Color" mt={"mt-5"}>
                <SectionRow triple={true}>
                  <InputContainer label="Primario" labelSize={3}>
                    <Form.Control
                      name="Color1"
                      type="color"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Color1}
                      disabled={isReadonly}
                    />
                  </InputContainer>
                  <InputContainer
                    label="Secundario"
                    labelSize={3}
                    labelClassName="pl-2 d-flex"
                  >
                    <Form.Control
                      name="Color2"
                      type="color"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Color2}
                      disabled={isReadonly}
                    />
                  </InputContainer>
                  <InputContainer label="Logo">
                    <Form.Control
                      name="Color3"
                      type="color"
                      onChange={(e) => FormHelper.handleChange(e, setCompania)}
                      value={compania.Color3}
                      disabled={isReadonly}
                    />
                  </InputContainer>
                </SectionRow>
              </EditSection>
            </EditSection>
          </EditContainer>
        </Card>
      </Form>
    </>
  )
}